/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskAutomationSummaryType from '@jira/spa-apps__project-settings-service-desk-automation-summary/src/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskAutomationSummary: LazyComponent<
	() => React.JSX.Element
> = lazyForPaint<typeof ProjectSettingsServiceDeskAutomationSummaryType>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-automation-summary", jiraSpaEntry: "async-project-settings-service-desk-automation-summary" */ '@jira/spa-apps__project-settings-service-desk-automation-summary/src/index.tsx'
		),
);

const AsyncProjectSettingsServiceDeskAutomationSummary = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskAutomationSummary}
		pageId="project-settings-automation-summary"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskAutomationSummary;
